/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import type {StyleHeaderInnerProps} from './style-header.types';
import {STYLE_HEADER_DEFAULT_TOP_MARGIN} from './style-header.types';
import styles from './style-header.module.scss';

/** Lets the tile-meta library exclude these non-interactive heading separators from the tile list. */
export const STYLE_HEADER_CONTROLS = new Set<EmailMakerControl>();

function StyleHeaderInner({labelKey, withTopMargin}: StyleHeaderInnerProps): ReactElement {
  const className = withTopMargin ? `${styles.header} ${styles.headerWithTopMargin}` : styles.header;
  return <Text bold className={className} size={TextSize.MD} val={window.i18next.t(labelKey)} />;
}

export function makeStyleHeader(labelKey: string, withTopMargin: boolean = STYLE_HEADER_DEFAULT_TOP_MARGIN): EmailMakerControl {
  const styleHeader = function (props: EmailMakerControlProps): ReactElement {
    return <StyleHeaderInner {...props} labelKey={labelKey} withTopMargin={withTopMargin} />;
  };
  STYLE_HEADER_CONTROLS.add(styleHeader);
  return styleHeader;
}
